import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';

export const SearchDialogTitle = styled(DialogTitle)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});
